// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.filters_wY0Xq {
  padding : var( --size-padLarge, 16px );
}

.layout_R3Bp6 {
  display : grid;
  grid-template-columns: 1fr 400px;
}

.editor_d1vLa {
  border-left : 4px solid var( --color-base100, #eeeeee );
}

.padding_lEZVA {
  padding : var( --size-padMedium, 8px ) 0;
}

.permission_IrJy6 {
  padding-left: var( --size-padLarge, 16px );
}`, "",{"version":3,"sources":["webpack://./src/screens/role/PermissionScreen.css"],"names":[],"mappings":";AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["\n.filters {\n  padding : var( --size-padLarge, 16px );\n}\n\n.layout {\n  display : grid;\n  grid-template-columns: 1fr 400px;\n}\n\n.editor {\n  border-left : 4px solid var( --color-base100, #eeeeee );\n}\n\n.padding {\n  padding : var( --size-padMedium, 8px ) 0;\n}\n\n.permission {\n  padding-left: var( --size-padLarge, 16px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `filters_wY0Xq`,
	"layout": `layout_R3Bp6`,
	"editor": `editor_d1vLa`,
	"padding": `padding_lEZVA`,
	"permission": `permission_IrJy6`
};
export default ___CSS_LOADER_EXPORT___;
